module.exports = __webpack_public_path__ + "static/img/gzgf_cd_pic.008c0bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gzgf_cd_pic.png
// module id = GJRY
// module chunks = 200